import React, { useEffect } from 'react';
import NotificationItem from './NotificationItem';
import { Event } from 'nostr-tools';
import { Bell } from 'lucide-react';

interface NotificationListProps {
    events: Event[];
    isLoading: boolean;
    loadMore?: () => void;
    hasMore?: boolean; // Optional if we implement infinite scroll later
}

const NotificationList: React.FC<NotificationListProps> = ({ events, isLoading, loadMore }) => {
    // Simple infinite scroll trigger for now
    useEffect(() => {
        // Placeholder for future scroll logic
    }, [isLoading, loadMore]);

    if (isLoading && events.length === 0) {
        return (
            <div className="space-y-4 p-4">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="flex gap-4 animate-pulse">
                        <div className="w-10 h-10 bg-gray-200 dark:bg-surface-800 rounded-full shrink-0" />
                        <div className="flex-1 space-y-2">
                            <div className="h-4 bg-gray-200 dark:bg-surface-800 rounded w-1/3" />
                            <div className="h-3 bg-gray-200 dark:bg-surface-800 rounded w-2/3" />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (events.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center p-12 text-center">
                <div className="w-16 h-16 bg-gray-100 dark:bg-surface-800 rounded-full flex items-center justify-center mb-4">
                    <Bell className="w-8 h-8 text-gray-400" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white font-poppins mb-2">
                    Henüz bildirim yok
                </h3>
                <p className="text-gray-500 dark:text-gray-400 font-poppins max-w-sm">
                    Etkileşimleriniz burada görünecek. Entry yazarak veya diğer yazarlarla etkileşime girerek başlayabilirsiniz.
                </p>
            </div>
        );
    }

    return (
        <ul className="divide-y divide-gray-100 dark:divide-surface-800">
            {events.map((event) => (
                <NotificationItem key={event.id} event={event} />
            ))}
            {loadMore && (
                <div className="p-4 text-center">
                    <button
                        onClick={loadMore}
                        disabled={isLoading}
                        className="text-sm text-mavi-500 hover:text-mavi-600 font-medium disabled:opacity-50"
                    >
                        {isLoading ? 'Yükleniyor...' : 'Daha Fazla Göster'}
                    </button>
                </div>
            )}
        </ul>
    );
};

export default NotificationList;
